// src/pages/index.jsx
import { useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import EnergieberegnerLayout from '../components/EnergieberegnerLayout';
import ProjectPickerModal from '../components/ProjectPickerModal';
import { useProjects } from '../context/ProjectContext';

import uvalueIcon from '../images/icons/uvalue.png';
import varmetabIcon from '../images/icons/varmetab.png';
import savingsIcon from '../images/icons/savings.png';
import styles from '../styles/LandingCards.module.css';

const CARDS = [
    {
        href: '/uvalue', icon: uvalueIcon, title: 'U-værdi',
        blurb: 'Beregn lag-for-lag U-værdier – inkl. tillæg A.2 og A.3.'
    },
    {
        href: '/varmetab', icon: varmetabIcon, title: 'Varmetabs-ramme',
        blurb: 'Tjek om bygningen holder DS 418-rammen. Indlæs dine gemte U-værdier.'
    },
    {
        href: '/savings', icon: savingsIcon, title: 'Årlig besparelse',
        blurb: 'Se hvor mange kWh (og kroner) du sparer på hele bygningen eller en konstruktion.'
    }
];

export default function Home() {
    const router = useRouter();
    const { activeProjectName } = useProjects();
    const [pendingHref, setHref] = useState(null);

    const nav = href => {
        if (activeProjectName) router.push(href);
        else setHref(href);                 // open picker first
    };

    return (
        <EnergieberegnerLayout title="Energiberegneren" showTabs={false}>
            <section className={styles.grid}>
                {CARDS.map(c => (
                    <button key={c.href} className={styles.card} onClick={() => nav(c.href)}>
                        <Image src={c.icon} alt="" width={60} height={60} priority />
                        <h2>{c.title}</h2>
                        <p>{c.blurb}</p>
                    </button>
                ))}
            </section>

            {/* one shared modal – sets project, then navigates */}
            <ProjectPickerModal
                open={Boolean(pendingHref)}
                pendingHref={pendingHref}
                onClose={href => {
                    setHref(null);
                    if (href) router.push(href);
                }}
            />
        </EnergieberegnerLayout>
    );
}
